<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="1180px" scrollable>
    <v-card class="nz-dlg">
      <!-- 1. TRAKA -->
      <div class="traka-radnik">
        <div>
          <div class="naslov">Neoporezivi primici – {{ imeRadnika }}</div>
          <div class="pod">
            Iskorišteni iznosi čitaju se iz spremljenih obračuna plaće te godine (polja neoporezivih dodataka 1–5,
            razdoblje po datumu JOPPD-a), a razvrstavaju po JOPPD oznaci primitka. Ništa se ne upisuje u bazu.
          </div>
        </div>
        <div class="razmak"></div>
        <div class="akcije">
          <span class="godina-fix">Godina {{ godina }}. (tekuća)</span>
          <v-btn small outlined dark class="gumb-duh" @click="$emit('input', false)">Zatvori</v-btn>
        </div>
      </div>

      <v-card-text class="nz-tijelo">
        <v-progress-linear v-if="ucitavam" indeterminate class="mb-2"></v-progress-linear>
        <v-alert v-if="greska" type="error" dense text>{{ greska }}</v-alert>

        <template v-if="podaci">
          <v-alert v-for="(u, i) in podaci.upozorenja" :key="'su' + i" type="warning" dense text>{{ u }}</v-alert>

          <!-- 2. BROJKE -->
          <div class="brojke">
            <div class="stavka"><span>Ukupno neoporezivo isplaćeno u {{ godina }}.</span><b class="glavno">{{ eur(podaci.ukupno) }}</b></div>
            <div class="crta"></div>
            <div class="stavka"><span>Ovaj obračun ({{ nazivMjeseca }} {{ godina }}.)</span><b>{{ eur(ovajObracun) }}</b></div>
            <div class="crta"></div>
            <div class="stavka"><span>Kategorija blizu limita (≥ 80 %)</span><b>{{ blizuLimita }}</b></div>
            <div class="crta"></div>
            <div class="stavka"><span>Upozorenja</span><b :class="{ lose: upozorenja.length }">{{ upozorenja.length }}</b></div>
            <div class="crta"></div>
            <div class="stavka"><span>Višak preko limita</span><b :class="{ lose: ukupniVisak }">{{ eur(ukupniVisak) }}</b></div>
            <div class="crta"></div>
            <div class="stavka"><span>Čeka odluku</span><b :class="{ lose: prijenos.brojNerijesenih }">{{ prijenos.brojNerijesenih }}</b></div>
          </div>

          <div v-if="upozorenja.length" class="vrijedi">
            <b>Upozorenja ({{ upozorenja.length }}):</b>
            <div v-for="(u, i) in upozorenja" :key="'u' + i">{{ u }}</div>
          </div>

          <!-- Podaci koji traze paznju -->
          <div v-if="pazljivo.length || podaci.naHZZO.ukupno > 0 || iznosBezOznake > 0" class="kartica" :class="{ zatvorena: !prikaziPodatke }">
            <div class="naslov-kartice sklopiva" @click="prikaziPodatke = !prikaziPodatke">
              Napomene o podacima ({{ pazljivo.length + (iznosBezOznake > 0 ? 1 : 0) }})
              <span class="dodatak">prikazano kako je upisano u obračunima — ništa se ne ispravlja</span>
              <span class="strelica">{{ prikaziPodatke ? 'sakrij' : 'prikaži' }}</span>
            </div>
            <div class="tijelo bez scroll" v-show="prikaziPodatke">
              <table>
                <thead><tr><th>Mjesec</th><th>JOPPD</th><th>Opis retka u obračunu</th><th class="d">Iznos</th><th>Napomena</th></tr></thead>
                <tbody>
                  <tr v-for="(p, i) in pazljivo" :key="'p' + i">
                    <td>{{ nazivMjeseca2(p.mjesec) }} {{ godina }}.</td>
                    <td><span class="sifra" :class="{ nema: !p.oznaka }">{{ p.oznaka ? oznakaTekst(p.oznaka) : 'bez oznake' }}</span></td>
                    <td>{{ p.opis || '—' }}</td>
                    <td class="d">{{ fmt(p.iznos) }}</td>
                    <td><span class="poruka uputa">{{ p.tekst }}</span></td>
                  </tr>
                  <tr v-if="podaci.naHZZO.ukupno > 0">
                    <td colspan="3">Naknada plaće na teret HZZO-a (NaHZZOiznos) — neoporezivo, bez oznake i bez limita; ne ulazi u kategorije ni u zbroj gore</td>
                    <td class="d">{{ fmt(podaci.naHZZO.ukupno) }}</td>
                    <td><span class="poruka uputa">{{ podaci.naHZZO.stavke.length }} obračuna</span></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 3. GODISNJI LIMITI -->
          <div class="kartica">
            <div class="naslov-kartice">Godišnji limiti <span class="dodatak">može se isplatiti odjednom ili u dijelovima, do limita za godinu · klik na red prikazuje isplate</span></div>
            <div class="tijelo bez scroll">
              <table>
                <thead>
                  <tr>
                    <th>Kategorija</th><th>JOPPD</th><th class="d">Limit</th><th class="d">Iskorišteno</th><th class="d">Preostalo</th>
                    <th>Napredak</th><th class="d">U ovom obračunu</th><th class="d">Nakon unosa</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="g in godisnjiGlavni">
                    <tr :key="'g' + g.oznaka" class="kat" :class="{ otvoren: otvoreni[g.oznaka] }" @click="prebaci(g.oznaka)">
                      <td>
                        <span class="strjel">&#9656;</span><b>{{ g.naziv }}</b>
                        <span v-if="g.napomena" class="sub">{{ g.napomena }}</span>
                        <span v-if="g.poDjetetu" class="sub" @click.stop>
                          broj djece do 15 god.:
                          <input class="unos mali" type="number" min="1" step="1" v-model.number="brojDjece">
                          <span v-if="podaci.radnik.brojDjeceOlaksica">(u zapisu radnika označeno {{ podaci.radnik.brojDjeceOlaksica }} djece za olakšicu — to nije isto što i djeca do 15 god.)</span>
                        </span>
                      </td>
                      <td><span class="sifra">{{ oznakaTekst(g.oznaka) }}</span></td>
                      <td class="d">{{ ocjene[g.oznaka].limit == null ? 'limit nije naveden' : fmt(ocjene[g.oznaka].limit) }}</td>
                      <td class="d">{{ fmt(ocjene[g.oznaka].iskoristeno) }}</td>
                      <td class="d">{{ ocjene[g.oznaka].preostalo == null ? '—' : fmt(ocjene[g.oznaka].preostalo) }}</td>
                      <td>
                        <span class="traka-napretka"><i :class="boja(postotak(g.oznaka))" :style="{ width: Math.min(100, postotak(g.oznaka)) + '%' }"></i></span>
                        <span class="pct">{{ ocjene[g.oznaka].limit == null ? '' : Math.round(postotak(g.oznaka)) + ' %' }}</span>
                      </td>
                      <td class="d" @click.stop>
                        <input class="unos" :class="{ greska: ocjene[g.oznaka].visak }" type="number" min="0" step="0.01" v-model="unosi[g.oznaka]">
                        <neoporezivo-visak :visak="ocjene[g.oznaka].visak" :vrsta="ocjene[g.oznaka].vrstaVisaka" :odluka="odlukaZa('k' + g.oznaka)"
                          @odluka="odluci('k' + g.oznaka, $event, ocjene[g.oznaka].visak)"></neoporezivo-visak>
                      </td>
                      <td class="d nakon" :class="{ lose: ocjene[g.oznaka].visak }">{{ fmt(ocjene[g.oznaka].nakon) }}</td>
                    </tr>
                    <tr :key="'gd' + g.oznaka" class="detalji" :class="{ otvoren: otvoreni[g.oznaka] }">
                      <td colspan="8"><div v-if="otvoreni[g.oznaka]" v-html="detaljiHtml(g.oznaka)"></div></td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 4. MJESECNI -->
          <div class="kartica">
            <div class="naslov-kartice">Mjesečni primici <span class="dodatak">uz plaću, svaki mjesec posebno</span></div>
            <div class="tijelo">
              <p class="upute">
                Prehrana paušalno (65) i po računima (66) <b>ne mogu u istom mjesecu</b>. Paušal 65: do 100 €/mj; razlika do godišnjeg limita
                1.200 € smije se isplatiti uz plaću za 11. mj. koja se isplaćuje u 12. mj. (kvačica u retku, dostupna samo u prosincu).
                Terenski dodatak: limit je 30 € × broj dana u mjesecu.
              </p>
              <div class="scroll">
                <table>
                  <thead>
                    <tr>
                      <th>Kategorija</th><th>JOPPD</th><th class="d">Mjesečni limit</th><th class="d">Godišnji limit</th>
                      <th class="d">Iskorišteno u god.</th><th class="d">U ovom obračunu</th><th>Provjera</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="m in mjesecniGlavni" :key="'m' + m.oznaka">
                      <td><b>{{ m.naziv }}</b><span v-if="m.napomena" class="sub">{{ m.napomena }}</span></td>
                      <td><span class="sifra">{{ oznakaTekst(m.oznaka) }}</span></td>
                      <td class="d" v-html="limitMjHtml(m)"></td>
                      <td class="d">{{ m.limitGod ? fmt(m.limitGod) : '—' }}</td>
                      <td class="d">{{ fmt(ocjene[m.oznaka].iskoristeno) }}</td>
                      <td class="d">
                        <input class="unos" :class="{ greska: ocjene[m.oznaka].visak || (sukob && (m.oznaka === 65 || m.oznaka === 66)) }" type="number" min="0" step="0.01" v-model="unosi[m.oznaka]">
                      </td>
                      <td>
                        <label v-if="m.nadoplata" class="nadoplata">
                          <input type="checkbox" v-model="nadoplata65" :disabled="mjesec !== 11">
                          obračun za 11/12. mj. – nadoplata razlike do 1.200 €
                          <span v-if="mjesec !== 11" class="sub">(samo kad je mjesec isplate prosinac)</span>
                        </label>
                        <div v-if="ocjene[m.oznaka].nadoplata" class="poruka uputa">nadoplata (najviše {{ fmt(ocjene[m.oznaka].preostalo) }} €); limit od 100 €/mj ne vrijedi</div>
                        <div v-if="sukob && (m.oznaka === 65 || m.oznaka === 66)" class="poruka">ne mogu u istom mjesecu: u {{ nazivMjeseca }} već ima prehrane paušalno i po računima — ostavite samo jedno</div>
                        <neoporezivo-visak :visak="ocjene[m.oznaka].visak" :vrsta="ocjene[m.oznaka].vrstaVisaka" :odluka="odlukaZa('k' + m.oznaka)"
                          @odluka="odluci('k' + m.oznaka, $event, ocjene[m.oznaka].visak)"></neoporezivo-visak>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="naslov-kartice podnaslov">
              Isplaćeno po mjesecima u {{ godina }}. <span class="dodatak">tekući mjesec je istaknut; mjesec je mjesec datuma JOPPD-a</span>
            </div>
            <div class="tijelo bez scroll">
              <table>
                <thead>
                  <tr>
                    <th>Mjesec</th>
                    <th v-for="m in mjesecniGlavni" :key="'mh' + m.oznaka" class="d">{{ m.kratko || m.naziv }} <span class="sifra">{{ oznakaTekst(m.oznaka) }}</span></th>
                    <th class="d">Ukupno</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in 12" :key="'mr' + i" :class="{ 'tekuci-red': i - 1 === mjesec }">
                    <td>
                      {{ nazivMjeseca2(i) }}
                      <span v-if="i - 1 === mjesec" class="sifra">tekući</span>
                      <span v-if="prehranaSukobMjeseca(i - 1)" class="sifra nema" title="65 i 66 u istom mjesecu">65 i 66!</span>
                    </td>
                    <td v-for="m in mjesecniGlavni" :key="'mc' + m.oznaka + i" class="d">
                      <span v-if="iskMj(m.oznaka, i - 1)">{{ fmt(iskMj(m.oznaka, i - 1)) }}</span><span v-else class="nz">—</span>
                      <span v-if="i - 1 === mjesec && val(m.oznaka)" class="plus">+ {{ fmt(val(m.oznaka)) }}</span>
                    </td>
                    <td class="d"><b>{{ zbrojMjeseca(i - 1) ? fmt(zbrojMjeseca(i - 1)) : '—' }}</b></td>
                  </tr>
                  <tr class="zbroj">
                    <td>Isplaćeno u {{ godina }}.</td>
                    <td v-for="m in mjesecniGlavni" :key="'mz' + m.oznaka" class="d">{{ fmt(isk(m.oznaka)) }}</td>
                    <td class="d">{{ fmt(zbrojMjesecnihGlavnih) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- 5. PO DOGADAJU -->
          <div class="kartica">
            <div class="naslov-kartice">Po događaju <span class="dodatak">jednokratne potpore, jubilarne, otpremnine, dnevnice i km</span></div>
            <div class="tijelo bez scroll">
              <table>
                <thead><tr><th>Mjesec</th><th>Događaj (opis retka)</th><th>JOPPD</th><th class="d">Iznos</th><th class="d">Limit događaja</th><th>Napomena</th></tr></thead>
                <tbody>
                  <tr v-for="(d, i) in podaci.dogadaji" :key="'d' + i">
                    <td>{{ nazivMjeseca2(d.mjesec) }} {{ godina }}.</td>
                    <td><b>{{ d.opis || nazivKategorije(d.oznaka) }}</b></td>
                    <td><span class="sifra">{{ oznakaTekst(d.oznaka) }}</span></td>
                    <td class="d">{{ fmt(d.iznos) }}</td>
                    <td class="d">{{ d.limit == null ? 'nije utvrđen' : fmt(d.limit) }}</td>
                    <td>
                      <span v-if="d.preko" class="poruka">preko limita događaja</span>
                      <span v-else-if="d.napomena" class="poruka uputa">{{ d.napomena }}</span>
                      <span v-else class="nz">—</span>
                    </td>
                  </tr>
                  <tr v-if="!podaci.dogadaji.length"><td colspan="6" class="prazno">&nbsp;Nema isplata po događaju u {{ godina }}.</td></tr>
                  <tr v-else class="zbroj"><td colspan="3">Ukupno po događaju u {{ godina }}.</td><td class="d">{{ fmt(zbrojDogadaja) }}</td><td colspan="2"></td></tr>
                </tbody>
              </table>
            </div>
            <div class="tijelo" style="border-top: 1px solid rgba(0,0,0,.12)">
              <b style="font-size: 14px">Novi događaji u ovom obračunu</b>
              <div class="staz-info" v-if="podaci.radnik.staz">
                Staž radnika (za jubilarnu nagradu):
                <b>{{ podaci.radnik.staz.godine }} god.</b>
                <span v-if="podaci.radnik.staz.pouzdano">
                  — izračunato iz početka rada {{ datumHR(podaci.radnik.staz.pocetakRada) }}<span v-if="podaci.radnik.staz.dana > 0 && (podaci.radnik.staz.prije.godine || podaci.radnik.staz.prije.mjeseci || podaci.radnik.staz.prije.dani)"> i staža prije dolaska ({{ podaci.radnik.staz.prije.godine }} g. {{ podaci.radnik.staz.prije.mjeseci }} mj. {{ podaci.radnik.staz.prije.dani }} d.)</span>
                </span>
                <span v-else class="poruka" style="display: inline"> — početak rada nije upisan, pa staž nije pouzdan: odaberite godine staža ručno.</span>
              </div>
              <div v-for="d in dogadajiOcjene" :key="'nd' + d.red.id" class="novi-dogadaj">
                <select class="izbor" v-model="d.red.tipId">
                  <option value="">— odaberite događaj —</option>
                  <option v-for="t in tipoviGlavni" :key="t.id" :value="t.id">{{ t.naziv }}</option>
                  <optgroup label="Rjeđe (nisu na popisu računovodstva)">
                    <option v-for="t in tipoviRjede" :key="t.id" :value="t.id">{{ t.naziv }}</option>
                  </optgroup>
                </select>
                <label v-if="d.tip" class="oznaka-polja">
                  Količina ({{ d.tip.jedinicaNaziv || 'komada' }})
                  <input class="unos" type="number" min="0" step="1" v-model.number="d.red.kol" style="width: 80px">
                </label>
                <label v-if="d.tip" class="oznaka-polja">
                  Iznos €
                  <input class="unos" :class="{ greska: d.ocj && d.ocj.visak }" type="number" min="0" step="0.01" v-model="d.red.iznos">
                </label>
                <div v-if="d.tip && d.ocj">
                  <div style="font-size: 13px; color: rgba(0,0,0,.6)">
                    JOPPD <span class="sifra">{{ oznakaTekst(d.tip.oznaka) }}</span> · Limit događaja:
                    <b style="color: rgba(0,0,0,.87)">{{ d.ocj.limit == null ? 'limit nije naveden' : fmt(d.ocj.limit) + ' €' }}</b>
                    <span v-if="d.tip.mnozi && d.ocj.limit != null">({{ fmt(d.tip.jedinica) }} € × {{ d.red.kol }} {{ d.tip.jedinicaNaziv }})</span>
                    <span v-else-if="d.tip.godisnje">({{ d.tip.po }}, preostalo nakon već isplaćenog)</span>
                  </div>
                  <div v-for="(p, pi) in porukeBezViska(d)" :key="'dp' + pi" class="poruka">{{ p }}</div>
                  <neoporezivo-visak :visak="d.ocj.visak" vrsta="limit događaja" :odluka="odlukaZa(d.kljuc)"
                    @odluka="odluci(d.kljuc, $event, d.ocj.visak)"></neoporezivo-visak>
                </div>
                <v-btn small text color="red" @click="ukloniDogadaj(d.red.id)">Ukloni</v-btn>
              </div>
              <v-btn small outlined color="primary" class="mt-2" @click="dodajDogadaj()">+ Dodaj događaj</v-btn>
            </div>
          </div>

          <!-- RJEDE KATEGORIJE -->
          <div class="kartica" :class="{ zatvorena: !prikaziRjede }">
            <div class="naslov-kartice sklopiva" @click="prikaziRjede = !prikaziRjede">
              Rjeđe kategorije (nisu na popisu računovodstva)
              <span class="dodatak">odmor, zdravstveno osiguranje, smještaj, vrtić/jaslice (70), putovanja vanjskih suradnika (8), stipendije učenicima (10), službeni put neprofitne org. (52), nagrade za prošla razdoblja (61), otpremnine</span>
              <span class="strelica">{{ prikaziRjede ? 'sakrij' : 'prikaži' }}</span>
            </div>
            <div class="tijelo bez scroll" v-show="prikaziRjede">
              <table>
                <thead><tr><th>Godišnji limit — kategorija</th><th>JOPPD</th><th class="d">Limit</th><th class="d">Iskorišteno</th><th class="d">Preostalo</th><th>Napredak</th><th class="d">U ovom obračunu</th><th class="d">Nakon unosa</th></tr></thead>
                <tbody>
                  <template v-for="g in godisnjiRjede">
                    <tr :key="'rg' + g.oznaka" class="kat" :class="{ otvoren: otvoreni[g.oznaka] }" @click="prebaci(g.oznaka)">
                      <td><span class="strjel">&#9656;</span><b>{{ g.naziv }}</b><span v-if="g.napomena" class="sub">{{ g.napomena }}</span></td>
                      <td><span class="sifra">{{ oznakaTekst(g.oznaka) }}</span></td>
                      <td class="d">{{ fmt(ocjene[g.oznaka].limit) }}</td>
                      <td class="d">{{ fmt(ocjene[g.oznaka].iskoristeno) }}</td>
                      <td class="d">{{ fmt(ocjene[g.oznaka].preostalo) }}</td>
                      <td>
                        <span class="traka-napretka"><i :class="boja(postotak(g.oznaka))" :style="{ width: Math.min(100, postotak(g.oznaka)) + '%' }"></i></span>
                        <span class="pct">{{ Math.round(postotak(g.oznaka)) + ' %' }}</span>
                      </td>
                      <td class="d" @click.stop>
                        <input class="unos" :class="{ greska: ocjene[g.oznaka].visak }" type="number" min="0" step="0.01" v-model="unosi[g.oznaka]">
                        <neoporezivo-visak :visak="ocjene[g.oznaka].visak" :vrsta="ocjene[g.oznaka].vrstaVisaka" :odluka="odlukaZa('k' + g.oznaka)"
                          @odluka="odluci('k' + g.oznaka, $event, ocjene[g.oznaka].visak)"></neoporezivo-visak>
                      </td>
                      <td class="d nakon" :class="{ lose: ocjene[g.oznaka].visak }">{{ fmt(ocjene[g.oznaka].nakon) }}</td>
                    </tr>
                    <tr :key="'rgd' + g.oznaka" class="detalji" :class="{ otvoren: otvoreni[g.oznaka] }">
                      <td colspan="8"><div v-if="otvoreni[g.oznaka]" v-html="detaljiHtml(g.oznaka)"></div></td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <table style="margin-top: 10px">
                <thead><tr><th>Mjesečno — kategorija</th><th>JOPPD</th><th class="d">Iskorišteno u god.</th><th class="d">U ovom obračunu</th><th>Limit</th></tr></thead>
                <tbody>
                  <tr v-for="m in mjesecniRjede" :key="'rm' + m.oznaka">
                    <td><b>{{ m.naziv }}</b><span v-if="m.napomena" class="sub">{{ m.napomena }}</span></td>
                    <td><span class="sifra">{{ m.oznakaTekst || oznakaTekst(m.oznaka) }}</span></td>
                    <td class="d">{{ fmt(ocjene[m.oznaka].iskoristeno) }}</td>
                    <td class="d"><input class="unos" type="number" min="0" step="0.01" v-model="unosi[m.oznaka]"></td>
                    <td><span class="nz" style="color: rgba(0,0,0,.6)">limit nije naveden</span></td>
                  </tr>
                </tbody>
              </table>
              <p class="upute" style="padding: 8px 16px 0">
                Otpremnine nalaze se u izborniku „Novi događaj" pod „Rjeđe": odlazak u mirovinu (26), poslovno/osobno uvjetovani otkaz (15),
                zbog ozljede na radu (16) i otkaz koji daje poslodavac (27; limit nije naveden pa nema upozorenja o limitu).
              </p>
            </div>
          </div>

          <!-- 7. SAZETAK -->
          <div class="kartica">
            <div class="naslov-kartice">Što bi se prenijelo u isplatnu listu <span class="dodatak">neoporezivi dodaci, kao u formi plaće (oznaka · kolona 15.1 / 15.2 · iznos)</span></div>
            <div class="tijelo">
              <div class="scroll">
                <table class="sazetak">
                  <thead><tr><th>Opis (kolona „Opis")</th><th>Joppd oznaka</th><th>Joppd kolona</th><th class="d">Iznos</th></tr></thead>
                  <tbody>
                    <tr class="skupina"><td colspan="4">1. Neoporezivi dio (do limita)</td></tr>
                    <tr v-for="s in prijenos.neoporezivo" :key="'sn' + s.kljuc">
                      <td>{{ s.opis }}</td>
                      <td><span class="sifra">{{ oznakaTekst(s.oznaka) }}</span></td>
                      <td>
                        <select class="izbor" :value="kolone[s.kljuc] || '15.1'" @change="$set(kolone, s.kljuc, $event.target.value)">
                          <option value="15.1">15.1</option><option value="15.2">15.2</option>
                        </select>
                      </td>
                      <td class="d">{{ fmt(s.iznos) }}</td>
                    </tr>
                    <tr v-if="!prijenos.neoporezivo.length"><td colspan="4" class="prazno">Nijedan iznos nije unesen u ovom obračunu.</td></tr>
                    <tr class="ukupno"><td colspan="3">Neoporezivo za ovaj obračun (zbroj kolona 15.1 / 15.2)</td><td class="iznos d">{{ eur(prijenos.zbrojNeoporezivo) }}</td></tr>

                    <template v-if="prijenos.ceka.length">
                      <tr class="skupina"><td colspan="4">2. Višak koji čeka odobrenje — nije nigdje dodan</td></tr>
                      <tr v-for="s in prijenos.ceka" :key="'sc' + s.kljuc" class="cekanje-red">
                        <td>{{ s.opis }} — višak</td><td><span class="sifra">{{ oznakaTekst(s.oznaka) }}</span></td><td>bruto plaća</td><td class="d">{{ fmt(s.iznos) }}</td>
                      </tr>
                      <tr class="podzbroj cekanje-red"><td colspan="3">Čeka odluku ({{ prijenos.ceka.length }})</td><td class="d">{{ eur(prijenos.zbrojCeka) }}</td></tr>
                    </template>
                    <template v-if="prijenos.odobreno.length">
                      <tr class="skupina"><td colspan="4">3. Višak odobren za bruto plaću</td></tr>
                      <tr v-for="s in prijenos.odobreno" :key="'so' + s.kljuc">
                        <td>{{ s.opis }} — višak</td><td><span class="sifra">{{ oznakaTekst(s.oznaka) }}</span></td><td>bruto plaća</td><td class="d">{{ fmt(s.iznos) }}</td>
                      </tr>
                      <tr class="podzbroj"><td colspan="3">Povećava bruto plaću za (oporezuje se kao plaća)</td><td class="d visak">{{ eur(prijenos.zbrojOdobreno) }}</td></tr>
                    </template>
                    <template v-if="prijenos.odbijeno.length">
                      <tr class="skupina"><td colspan="4">Višak odbijen — ne prenosi se</td></tr>
                      <tr v-for="s in prijenos.odbijeno" :key="'sb' + s.kljuc">
                        <td>{{ s.opis }} — višak</td><td colspan="2">odbijeno</td><td class="d">{{ fmt(s.iznos) }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <div v-if="prijenos.uputa" class="poruka" style="max-width: none">{{ prijenos.uputa }}</div>
              <div v-else-if="prijenos.zbrojOdobreno" class="poruka uputa" style="max-width: none">
                Odobreni višak od {{ eur(prijenos.zbrojOdobreno) }} povećava bruto plaću radnika i oporezuje se kao plaća (porez i doprinosi).
              </div>
              <v-alert v-if="prijenos.previseStavki" type="warning" dense text class="mt-2 mb-0">
                Forma plaće ima samo {{ podaci.maxStavki }} retka neoporezivih dodataka, a ovdje je {{ prijenos.neoporezivo.length }} stavki.
                Spojite stavke iste oznake ili ih unesite u dva obračuna.
              </v-alert>
              <v-alert type="info" dense text class="mt-2 mb-0">
                Prijenos u formu plaće još <b>nije spojen</b>. Gumb „Prenesi u isplatnu listu" samo izračuna i prikaže popis stavki,
                a popis možete kopirati u međuspremnik. Ništa se ne upisuje u bazu ni u formu plaće (kad se zatraži, spojit će se u formi plaće).
              </v-alert>
              <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 10px; flex-wrap: wrap">
                <v-btn color="primary" depressed :disabled="!prijenos.mozeSePrenijeti" @click="prenesi()">Prenesi u isplatnu listu</v-btn>
              </div>

              <div v-if="preneseno" class="preneseno">
                <div class="naslov-kartice" style="font-size: 15px">Popis stavki koje bi se prenijele (samo prikaz)</div>
                <table>
                  <thead><tr><th>#</th><th>Opis</th><th>Oznaka</th><th>Kolona</th><th class="d">Iznos</th></tr></thead>
                  <tbody>
                    <tr v-for="(s, i) in preneseno.stavke" :key="'pr' + i">
                      <td>{{ i + 1 }}</td><td>{{ s.opis }}</td><td><span class="sifra">{{ oznakaTekst(s.oznaka) }}</span></td><td>{{ s.kolona }}</td><td class="d">{{ fmt(s.iznos) }}</td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="preneseno.visakBruto" class="poruka uputa" style="max-width: none">
                  Višak odobren za bruto plaću: {{ eur(preneseno.visakBruto) }} (dodaje se u bruto plaću, ne u neoporezive retke).
                </div>
                <v-alert v-if="preneseno.stavke.length > podaci.maxStavki" type="warning" dense text class="mt-2 mb-0">
                  Stavki ima više od {{ podaci.maxStavki }} (koliko stane u formu plaće).
                </v-alert>
                <div style="display: flex; justify-content: flex-end; gap: 8px; margin-top: 8px">
                  <span v-if="kopirano" class="poruka uputa" style="align-self: center">{{ kopirano }}</span>
                  <v-btn small outlined color="primary" @click="kopiraj()">Kopiraj u međuspremnik</v-btn>
                </div>
              </div>
            </div>
          </div>
        </template>
      </v-card-text>

      <v-dialog v-model="potvrdaDialog" max-width="480">
        <v-card>
          <v-card-title class="subtitle-1">Višak u bruto plaću</v-card-title>
          <v-card-text>Dodaje se {{ eur(prijenos.potvrdaViska) }} u bruto plaću radnika {{ imeRadnika }} — potvrdi</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="potvrdaDialog = false">Odustani</v-btn>
            <v-btn color="primary" depressed @click="potvrdiPrijenos()">Potvrdi</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import SalarieService from '@/services/SalarieService'
import NeoporezivoVisak from './NeoporezivoVisak'
import { ocijeniKategoriju, ocijeniDogadaj, sukobPrehrane, sastaviPrijenos, oznakaTekst } from './neoporezivoLogika'

const MJESECI = ['siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj', 'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac']
const norm = (s) => String(s || '').trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/đ/g, 'd').replace(/\s+/g, ' ')
const esc = (s) => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')

export default {
  name: 'neoporezivopregleddialog',
  components: { NeoporezivoVisak },
  props: {
    value: { type: Boolean, default: false },
    // radnik (actionType 1) ili detalj obracuna plaće (actionType 2: id = detalj, empID = radnik)
    employee: { type: Object, default: () => ({}) },
    actionType: { type: Number, default: 1 }
  },
  data () {
    return {
      ucitavam: false,
      greska: '',
      podaci: null,
      unosi: {},
      brojDjece: 1,
      nadoplata65: false,
      noviDogadaji: [],
      brojacDogadaja: 0,
      odluke: {},
      kolone: {},
      otvoreni: {},
      prikaziRjede: false,
      prikaziPodatke: true,
      preneseno: null,
      kopirano: '',
      potvrdaDialog: false,
      nerazvrstano: [],
      godina: new Date().getFullYear(),
      mjesec: new Date().getMonth()
    }
  },
  computed: {
    imeRadnika () {
      return [this.employee.First, this.employee.Last].filter(Boolean).join(' ')
    },
    radnikId () { return this.actionType === 2 ? this.employee.empID : this.employee.id },
    nazivMjeseca () { return MJESECI[this.mjesec] },
    kategorije () { return this.podaci ? this.podaci.kategorije : [] },
    godisnjiGlavni () { return this.kategorije.filter(k => k.grupa === 'godisnji' && k.glavna) },
    godisnjiRjede () { return this.kategorije.filter(k => k.grupa === 'godisnji' && !k.glavna) },
    mjesecniGlavni () { return this.kategorije.filter(k => k.grupa === 'mjesecni' && k.glavna) },
    mjesecniRjede () { return this.kategorije.filter(k => k.grupa === 'mjesecni' && !k.glavna) },
    kategorijeTablice () { return this.kategorije.filter(k => k.grupa !== 'dogadaj') },
    tipoviGlavni () { return this.podaci ? this.podaci.tipoviDogadaja.filter(t => !t.rjede) : [] },
    tipoviRjede () { return this.podaci ? this.podaci.tipoviDogadaja.filter(t => t.rjede) : [] },
    ocjene () {
      const out = {}
      if (!this.podaci) { return out }
      this.kategorijeTablice.forEach(kat => {
        out[kat.oznaka] = ocijeniKategoriju(kat, {
          iskGod: this.isk(kat.oznaka),
          iskMjesec: this.iskMj(kat.oznaka, this.mjesec),
          unos: this.val(kat.oznaka),
          godina: this.godina,
          mjesec: this.mjesec,
          nadoplata: this.nadoplata65,
          brojDjece: this.brojDjece
        })
      })
      return out
    },
    sukob () {
      if (!this.podaci) { return false }
      return sukobPrehrane(this.iskMj(65, this.mjesec), this.val(65), this.iskMj(66, this.mjesec), this.val(66))
    },
    dogadajiOcjene () {
      return this.noviDogadaji.map(red => {
        const tip = this.podaci ? this.podaci.tipoviDogadaja.find(t => t.id === red.tipId) : null
        const ocj = tip ? ocijeniDogadaj(tip, red.kol, red.iznos, this.iskGodisnjeDogadaja(tip), this.podaci.jubilarne) : null
        return { red, tip, ocj, kljuc: 'd' + red.id }
      })
    },
    linije () {
      const l = []
      this.kategorijeTablice.forEach(kat => {
        const u = this.val(kat.oznaka)
        if (u > 0) {
          l.push({ kljuc: 'k' + kat.oznaka, opis: kat.kratko || kat.naziv, oznaka: kat.oznaka, iznos: u, visak: this.ocjene[kat.oznaka].visak, kolona: this.kolone['k' + kat.oznaka] || '15.1' })
        }
      })
      this.dogadajiOcjene.forEach(d => {
        const iznos = parseFloat(d.red.iznos) || 0
        if (d.tip && iznos > 0) {
          l.push({ kljuc: d.kljuc, opis: d.tip.naziv.replace(/\s*\(količina[^)]*\)/, ''), oznaka: d.tip.oznaka, iznos: iznos, visak: d.ocj.visak, kolona: this.kolone[d.kljuc] || '15.1' })
        }
      })
      return l
    },
    // odluka vrijedi samo za visak za koji je donesena (promijeni li se unos, ponovo "ceka odluku")
    odlukeEf () {
      const o = {}
      this.linije.forEach(l => {
        const x = this.odluke[l.kljuc]
        if (l.visak > 0 && x && x.iznos === l.visak) { o[l.kljuc] = x.odluka }
      })
      return o
    },
    prijenos () {
      return sastaviPrijenos(this.linije, this.odlukeEf, this.podaci ? this.podaci.maxStavki : 5)
    },
    ovajObracun () {
      return this.linije.reduce((s, l) => s + l.iznos, 0)
    },
    ukupniVisak () {
      return this.linije.reduce((s, l) => s + l.visak, 0)
    },
    blizuLimita () {
      if (!this.podaci) { return 0 }
      let n = 0
      this.kategorijeTablice.forEach(kat => {
        const o = this.ocjene[kat.oznaka]
        if (!o || o.limit == null || !o.limit) { return }
        const mjesecno = kat.grupa === 'mjesecni' && o.limitMj != null
        const potroseno = mjesecno ? this.iskMj(kat.oznaka, this.mjesec) + this.val(kat.oznaka) : o.nakon
        if (potroseno / o.limit >= 0.8) { n++ }
      })
      return n
    },
    upozorenja () {
      const u = []
      if (!this.podaci) { return u }
      this.kategorijeTablice.forEach(kat => {
        const o = this.ocjene[kat.oznaka]
        if (o && o.visak) { u.push(kat.naziv + ': prelazi ' + (o.vrstaVisaka || 'limit') + ' za ' + this.eur(o.visak)) }
      })
      this.dogadajiOcjene.forEach(d => {
        if (d.tip && d.ocj) { d.ocj.poruke.forEach(p => u.push(d.tip.naziv + ': ' + p)) }
      })
      if (this.sukob) { u.push('Prehrana: paušal (65) i po računima (66) ne mogu u istom mjesecu') }
      this.nerazvrstano.forEach(n => u.push('U obračunu je stavka bez oznake ili s oznakom izvan popisa: ' + n))
      return u
    },
    pazljivo () {
      return this.podaci ? this.podaci.upozorenjaPodataka : []
    },
    iznosBezOznake () {
      return this.podaci ? this.podaci.bezOznake.ukupno : 0
    },
    zbrojDogadaja () {
      return this.podaci ? this.podaci.dogadaji.reduce((s, d) => s + d.iznos, 0) : 0
    },
    zbrojMjesecnihGlavnih () {
      return this.mjesecniGlavni.reduce((s, m) => s + this.isk(m.oznaka), 0)
    }
  },
  watch: {
    value (otvoren) {
      if (otvoren) { this.ucitaj() }
    }
  },
  mounted () {
    if (this.value) { this.ucitaj() }
  },
  methods: {
    oznakaTekst,
    fmt (n) {
      const x = Math.round((Number(n) || 0) * 100) / 100
      const neg = x < 0
      const s = Math.abs(x).toFixed(2).split('.')
      return (neg ? '-' : '') + s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1]
    },
    eur (n) { return this.fmt(n) + ' €' },
    nazivMjeseca2 (i) { return MJESECI[i - 1] || '' },
    datumHR (d) {
      const x = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ''))
      return x ? x[3] + '.' + x[2] + '.' + x[1] + '.' : ''
    },
    boja (p) { return p > 100 ? 'crvena' : (p >= 80 ? 'zuta' : '') },
    val (oznaka) {
      const v = parseFloat(this.unosi[oznaka])
      return isNaN(v) || v < 0 ? 0 : v
    },
    isk (oznaka) {
      const o = this.podaci && this.podaci.poOznaci[oznaka]
      return o ? o.ukupno : 0
    },
    iskMj (oznaka, mj) {
      const o = this.podaci && this.podaci.poOznaci[oznaka]
      return o ? o.poMjesecu[mj] : 0
    },
    zbrojMjeseca (mj) {
      return this.mjesecniGlavni.reduce((s, m) => s + this.iskMj(m.oznaka, mj), 0)
    },
    prehranaSukobMjeseca (mj) {
      return this.iskMj(65, mj) > 0 && this.iskMj(66, mj) > 0
    },
    postotak (oznaka) {
      const o = this.ocjene[oznaka]
      return o && o.limit ? o.nakon / o.limit * 100 : 0
    },
    nazivKategorije (oznaka) {
      const k = this.kategorije.find(x => x.oznaka === oznaka)
      return k ? k.naziv : oznakaTekst(oznaka)
    },
    iskGodisnjeDogadaja (tip) {
      if (!tip.godisnje || !tip.opisRegex) { return 0 }
      const o = this.podaci.poOznaci[tip.oznaka]
      if (!o) { return 0 }
      const re = new RegExp(tip.opisRegex)
      return o.stavke.filter(s => re.test(norm(s.opis))).reduce((a, s) => a + s.iznos, 0)
    },
    limitMjHtml (m) {
      const o = this.ocjene[m.oznaka]
      if (!o) { return '' }
      if (m.limitDan) {
        return this.fmt(o.limitMj) + '<span class="sub">' + m.limitDan + ' € × ' + (o.limitMj / m.limitDan) + ' dana</span>'
      }
      if (o.limitMj != null) { return this.fmt(o.limitMj) }
      if (m.oznaka === 17 || m.oznaka === 18) { return '<span class="nz2">po danu / km (vidi Po događaju)</span>' }
      if (m.oznaka === 19) { return '<span class="nz2">prema cijeni karte</span>' }
      if (m.oznaka === 66) { return '<span class="nz2">—</span>' }
      return '<span class="nz2">limit nije naveden</span>'
    },
    porukeBezViska (d) {
      return d.ocj.poruke.filter(x => x.indexOf('prelazi') !== 0)
    },
    prebaci (oznaka) {
      this.$set(this.otvoreni, oznaka, !this.otvoreni[oznaka])
    },
    detaljiHtml (oznaka) {
      const o = this.podaci.poOznaci[oznaka]
      if (!o || !o.stavke.length) { return '<span class="prazno" style="padding:0">Nema isplata u ' + this.godina + '.</span>' }
      let h = '<table class="mini"><thead><tr><th>Mjesec</th><th>Opis retka u obračunu</th><th>Vrsta obračuna</th><th style="text-align:right">Iznos</th><th></th></tr></thead><tbody>'
      o.stavke.forEach(s => {
        h += '<tr><td>' + MJESECI[s.mjesec - 1] + ' ' + this.godina + '.</td><td>' + (esc(s.opis) || '—') + '</td><td>' + esc(s.vrstaObracuna || 'Obračun plaće') +
          '</td><td style="text-align:right">' + this.fmt(s.iznos) + '</td><td>' + (s.napomena ? '<span class="poruka uputa">' + esc(s.napomena) + '</span>' : '') + '</td></tr>'
      })
      h += '</tbody></table>'
      if (o.vrste.length > 1) {
        h += '<div class="vrste">Po vrstama (opis retka): ' + o.vrste.map(v => esc(v.opis || 'bez opisa') + ' <b>' + this.fmt(v.ukupno) + '</b>').join(' · ') + '</div>'
      }
      return h
    },
    odlukaZa (kljuc) {
      return this.odlukeEf[kljuc] || null
    },
    odluci (kljuc, odluka, visak) {
      const x = this.odluke[kljuc]
      if (x && x.odluka === odluka && x.iznos === visak) { this.$delete(this.odluke, kljuc) } else { this.$set(this.odluke, kljuc, { odluka, iznos: visak }) }
    },
    dodajDogadaj (tipId, kol, iznos) {
      this.brojacDogadaja++
      this.noviDogadaji.push({ id: this.brojacDogadaja, tipId: tipId || '', kol: kol || 1, iznos: iznos || 0 })
    },
    ukloniDogadaj (id) {
      this.noviDogadaji = this.noviDogadaji.filter(d => d.id !== id)
      this.$delete(this.odluke, 'd' + id)
    },
    mjesecObracuna () {
      // mjesec isplate: iz datuma JOPPD-a obracuna koji se ureduje, ako je u tekucoj godini; inace tekuci mjesec
      const head = this.$store && this.$store.state ? this.$store.state.documentActivHead : null
      if (this.actionType === 2 && head && head.JoppdDate) {
        const d = new Date(head.JoppdDate)
        if (!isNaN(d.getTime()) && d.getFullYear() === this.godina) { return d.getMonth() }
      }
      return new Date().getMonth()
    },
    // vrijednosti koje u formi placa (actionType 2) vec stoje u retcima neoporezivih dodataka: "U ovom obracunu"
    iznosiIzForme () {
      const e = this.employee || {}
      const redci = []
      if (this.actionType !== 2) { return redci }
      for (let n = 1; n <= 5; n++) {
        const iznos = parseFloat(e['FinAdd' + n + '_Amount']) || 0
        if (iznos > 0) {
          const j = parseFloat(e['FinAdd' + n + '_JoppId']) || 0
          redci.push({ oznaka: Math.round(parseFloat(e['FinAdd' + n + '_TypeId']) || 0), iznos, opis: e['FinAdd' + n + '_Desc'] || '', kolona: j === 15.2 ? '15.2' : '15.1' })
        }
      }
      return redci
    },
    async ucitaj () {
      this.greska = ''
      this.preneseno = null
      this.kopirano = ''
      this.odluke = {}
      this.kolone = {}
      this.otvoreni = {}
      this.noviDogadaji = []
      this.nerazvrstano = []
      this.nadoplata65 = false
      this.brojDjece = 1
      this.godina = new Date().getFullYear()
      this.mjesec = this.mjesecObracuna()
      const companyId = this.employee.CompanyId || (this.$store && this.$store.state ? this.$store.state.companyid : null)
      if (!this.radnikId || !companyId) {
        this.greska = 'Nedostaje radnik ili firma.'
        return
      }
      this.zahtjev = (this.zahtjev || 0) + 1
      const moj = this.zahtjev
      this.ucitavam = true
      try {
        const query = { CompanyId: companyId, EmployeeId: this.radnikId, godina: this.godina }
        if (this.actionType === 2 && this.employee.id) { query.iskljuciDetailID = this.employee.id }
        const { data } = await SalarieService.neoporezivo(query)
        if (moj !== this.zahtjev) { return }
        const unosi = {}
        data.kategorije.forEach(k => { if (k.grupa !== 'dogadaj') { unosi[k.oznaka] = 0 } })
        this.podaci = data
        this.unosi = unosi
        this.prefillIzForme(data)
      } catch (err) {
        if (moj !== this.zahtjev) { return }
        const poruka = err && err.response && err.response.data && err.response.data.errors
        this.greska = poruka ? poruka.join(' ') : 'Podaci o neoporezivim primicima nisu učitani.'
      } finally {
        if (moj === this.zahtjev) { this.ucitavam = false }
      }
    },
    prefillIzForme (data) {
      const unosi = Object.assign({}, this.unosi)
      this.iznosiIzForme().forEach(r => {
        const kat = data.kategorije.find(k => k.oznaka === r.oznaka && k.grupa !== 'dogadaj')
        if (kat) {
          unosi[kat.oznaka] = Math.round(((parseFloat(unosi[kat.oznaka]) || 0) + r.iznos) * 100) / 100
          if (r.kolona === '15.2') { this.$set(this.kolone, 'k' + kat.oznaka, '15.2') }
          return
        }
        const tip = data.tipoviDogadaja.find(t => t.oznaka === r.oznaka)
        if (tip) {
          const kol = tip.jubilarna && data.radnik.staz ? data.radnik.staz.godine : 1
          this.dodajDogadaj(tip.id, kol, r.iznos)
          return
        }
        this.nerazvrstano.push((r.opis || 'bez opisa') + ' — ' + this.fmt(r.iznos) + ' € (oznaka ' + (r.oznaka ? oznakaTekst(r.oznaka) : 'nije upisana') + ')')
      })
      this.unosi = unosi
    },
    tekstPrijenosa () {
      const p = this.preneseno
      const linije = p.stavke.map((s, i) => (i + 1) + '. ' + s.opis + ' — oznaka ' + oznakaTekst(s.oznaka) + ' — kolona ' + s.kolona + ' — ' + this.fmt(s.iznos) + ' €')
      let t = 'Neoporezivi primici – ' + this.imeRadnika + ' (' + this.nazivMjeseca + ' ' + this.godina + '.)\n' + linije.join('\n')
      t += '\nNeoporezivo ukupno: ' + this.fmt(p.stavke.reduce((s, x) => s + x.iznos, 0)) + ' €'
      if (p.visakBruto) { t += '\nVišak odobren za bruto plaću: ' + this.fmt(p.visakBruto) + ' €' }
      return t
    },
    prenesi () {
      if (!this.prijenos.mozeSePrenijeti) { return }
      if (this.prijenos.potvrdaViska > 0) {
        this.potvrdaDialog = true
        return
      }
      this.potvrdiPrijenos()
    },
    potvrdiPrijenos () {
      this.potvrdaDialog = false
      const stavke = this.prijenos.stavkeZaFormu.map(s => ({ oznaka: s.oznaka, kolona: this.kolone[s.kljuc] || s.kolona || '15.1', iznos: s.iznos, opis: s.opis }))
      this.preneseno = { stavke, visakBruto: this.prijenos.potvrdaViska }
      this.kopirano = ''
      // roditelj za sada ne radi nista s ovim dogadajem (prijenos u formu place nije spojen)
      this.$emit('prenesi', { radnikId: this.radnikId, stavke, visakBruto: this.prijenos.potvrdaViska })
    },
    async kopiraj () {
      const tekst = this.tekstPrijenosa()
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(tekst)
        } else {
          const ta = document.createElement('textarea')
          ta.value = tekst
          document.body.appendChild(ta)
          ta.select()
          document.execCommand('copy')
          document.body.removeChild(ta)
        }
        this.kopirano = 'Kopirano u međuspremnik.'
      } catch (e) {
        this.kopirano = 'Kopiranje nije uspjelo.'
      }
    }
  }
}
</script>

<style>
.nz-dlg { --plava: #1976d2; --plava-tamna: #1565c0; --plava-svijetla: #eef4fb; --crta: rgba(0,0,0,.12); --sivo: rgba(0,0,0,.6);
  --zelena: #2e7d32; --zuta: #f9a825; --crvena: #c62828; --crvena-sv: #fdecea; background: #f5f5f5 !important; font-size: 15px; }
.nz-dlg button { font-family: inherit; }
.nz-dlg .traka-radnik { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; background: var(--plava); color: #fff; padding: 10px 14px; flex: 0 0 auto; }
.nz-dlg .traka-radnik .naslov { font-size: 20px; font-weight: 700; line-height: 1.2; }
.nz-dlg .traka-radnik .pod { font-size: 13px; opacity: .92; margin-top: 3px; max-width: 640px; }
.nz-dlg .traka-radnik .razmak { flex: 1; }
.nz-dlg .akcije { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.nz-dlg .godina-fix { font-size: 14px; font-weight: 700; background: rgba(255,255,255,.22); border-radius: 4px; padding: 6px 12px; }
.nz-dlg .gumb-duh { border-color: rgba(255,255,255,.7) !important; }
.nz-dlg .nz-tijelo { padding: 12px !important; max-height: 78vh; }

.nz-dlg .brojke { display: flex; flex-wrap: wrap; gap: 14px 26px; background: #fff; border: 1px solid var(--crta); border-radius: 4px; padding: 10px 16px; margin-bottom: 12px; }
.nz-dlg .brojke .stavka span { display: block; font-size: 12px; color: var(--sivo); line-height: 1.2; }
.nz-dlg .brojke .stavka b { font-size: 19px; font-variant-numeric: tabular-nums; }
.nz-dlg .brojke .stavka b.glavno { color: var(--plava-tamna); font-size: 22px; }
.nz-dlg .brojke .stavka b.lose { color: var(--crvena); }
.nz-dlg .brojke .crta { width: 1px; background: var(--crta); align-self: stretch; }

.nz-dlg .kartica { background: #fff; border: 1px solid var(--crta); border-radius: 4px; margin-bottom: 12px; overflow: hidden; }
.nz-dlg .naslov-kartice { font-size: 17px; font-weight: 700; letter-spacing: .02em; color: var(--plava-tamna); background: var(--plava-svijetla);
  border-bottom: 2px solid var(--plava); padding: 8px 16px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.nz-dlg .naslov-kartice.podnaslov { font-size: 14px; }
.nz-dlg .naslov-kartice .dodatak { font-size: 12px; font-weight: 400; color: var(--sivo); }
.nz-dlg .naslov-kartice.sklopiva { cursor: pointer; user-select: none; }
.nz-dlg .naslov-kartice .strelica { margin-left: auto; font-size: 13px; color: var(--sivo); font-weight: 400; }
.nz-dlg .tijelo { padding: 10px 16px 14px; }
.nz-dlg .tijelo.bez { padding: 0; }
.nz-dlg .upute { font-size: 13px; color: var(--sivo); margin: 0 0 8px; }
.nz-dlg .scroll { overflow-x: auto; }

.nz-dlg table { width: 100%; border-collapse: collapse; font-variant-numeric: tabular-nums; font-size: 14px; }
.nz-dlg th { text-align: left; font-size: 12px; font-weight: 500; color: var(--sivo); padding: 6px 10px; border-bottom: 1px solid var(--crta); background: #fafafa; white-space: nowrap; }
.nz-dlg td { padding: 6px 10px; border-bottom: 1px solid #f0f0f0; vertical-align: middle; }
.nz-dlg th.d, .nz-dlg td.d { text-align: right; }
.nz-dlg .nz { color: #cfd8dc; }
.nz-dlg tr.kat { cursor: pointer; }
.nz-dlg tr.kat:hover td { background: #f7fbff; }
.nz-dlg .strjel { display: inline-block; width: 14px; color: var(--sivo); transition: transform .15s; }
.nz-dlg tr.kat.otvoren .strjel { transform: rotate(90deg); }
.nz-dlg tr.detalji { display: none; }
.nz-dlg tr.detalji.otvoren { display: table-row; }
.nz-dlg tr.detalji td { background: #fafcff; padding: 8px 10px 12px 34px; }
.nz-dlg .sifra { display: inline-block; font-size: 12px; font-weight: 700; color: var(--plava-tamna); background: var(--plava-svijetla); border: 1px solid #c5d9ef; border-radius: 10px; padding: 0 8px; white-space: nowrap; }
.nz-dlg .sifra.nema { color: #8d6e00; background: #fff8e1; border-color: #ffe082; }
.nz-dlg .sub { display: block; font-size: 12px; color: var(--sivo); }
.nz-dlg .nz2 { color: var(--sivo); font-size: 12px; }

.nz-dlg .traka-napretka { width: 120px; height: 8px; background: #e3e8ee; border-radius: 4px; overflow: hidden; display: inline-block; vertical-align: middle; }
.nz-dlg .traka-napretka i { display: block; height: 100%; background: var(--zelena); }
.nz-dlg .traka-napretka i.zuta { background: var(--zuta); }
.nz-dlg .traka-napretka i.crvena { background: var(--crvena); }
.nz-dlg .pct { font-size: 12px; color: var(--sivo); margin-left: 6px; display: inline-block; width: 38px; text-align: right; }

.nz-dlg input.unos { font: inherit; width: 96px; text-align: right; padding: 4px 6px; border: 1px solid #b0bec5; border-radius: 4px; font-variant-numeric: tabular-nums; background: #fff; }
.nz-dlg input.unos.mali { width: 52px; }
.nz-dlg input.unos:focus { outline: 2px solid var(--plava); border-color: var(--plava); }
.nz-dlg input.unos.greska { border-color: var(--crvena); background: var(--crvena-sv); }
.nz-dlg select.izbor { font: inherit; font-size: 14px; padding: 4px 6px; border: 1px solid #b0bec5; border-radius: 4px; max-width: 100%; background: #fff; }
.nz-dlg .poruka { font-size: 12px; color: var(--crvena); font-weight: 500; margin-top: 3px; max-width: 320px; }
.nz-dlg .poruka.uputa { color: #8d6e00; }
.nz-dlg .nakon.lose { color: var(--crvena); font-weight: 700; }
.nz-dlg .nadoplata { font-size: 12px; display: block; margin-bottom: 3px; }

.nz-dlg .vrijedi { background: var(--crvena-sv); border: 1px solid #f5c2bd; color: #8e1b14; border-radius: 4px; padding: 8px 12px; font-size: 13px; margin-bottom: 10px; }
.nz-dlg tr.tekuci-red td { background: #e8f1fb; font-weight: 500; }
.nz-dlg .plus { color: var(--plava-tamna); font-style: italic; font-size: 12px; display: block; }
.nz-dlg tr.zbroj td { border-top: 2px solid var(--crta); font-weight: 700; background: #fafafa; }
.nz-dlg .prazno { color: var(--sivo); font-size: 14px; padding: 10px 0; }

.nz-dlg .novi-dogadaj { display: flex; gap: 10px; flex-wrap: wrap; align-items: flex-start; margin-top: 10px; padding-bottom: 8px; border-bottom: 1px dashed var(--crta); }
.nz-dlg .oznaka-polja { font-size: 13px; color: var(--sivo); }
.nz-dlg .staz-info { font-size: 13px; color: var(--sivo); margin-top: 6px; }
.nz-dlg .vrste { font-size: 12px; color: var(--sivo); margin-top: 6px; }

.nz-dlg .sazetak tr.skupina td { font-size: 12px; font-weight: 700; text-transform: uppercase; letter-spacing: .06em; color: var(--plava-tamna); background: var(--plava-svijetla); text-align: left; }
.nz-dlg .sazetak tr.podzbroj td { font-weight: 700; border-top: 1px solid var(--crta); }
.nz-dlg .sazetak tr.cekanje-red td { background: #fff8e1; }
.nz-dlg .sazetak tr.ukupno td { font-weight: 700; font-size: 16px; border-top: 2px solid var(--crta); }
.nz-dlg .sazetak tr.ukupno td.iznos { color: var(--plava-tamna); }
.nz-dlg .visak { color: var(--crvena); font-weight: 500; }
.nz-dlg .preneseno { margin-top: 14px; border: 1px solid var(--crta); border-radius: 4px; padding: 0 0 10px; }

.nz-dlg .kartica.zatvorena .tijelo { display: none; }

@media (max-width: 900px) {
  .nz-dlg .brojke .crta { display: none; }
  .nz-dlg .traka-radnik .razmak { display: none; }
  .nz-dlg .akcije { width: 100%; }
}
@media (max-width: 520px) {
  .nz-dlg input.unos { width: 80px; }
  .nz-dlg .traka-napretka { width: 80px; }
  .nz-dlg .nz-tijelo { padding: 8px !important; }
}
/* sadrzaj iz v-html */
.nz-dlg table.mini { width: auto; font-size: 13px; }
.nz-dlg table.mini td, .nz-dlg table.mini th { padding: 3px 12px 3px 0; border: none; background: none; }
</style>
